import { jsx as _jsx } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
export function SectionNote({ children }) {
    return /*#__PURE__*/ _jsx("p", {
        className: "text-sm text-muted-foreground",
        "data-testid": Testids.deliveryShared.sectionNote,
        children: children
    });
}
